import React, { Component } from 'react';
import get from 'lodash/get';

import FileHandler from '../../features/FileHandler';
import InfoBox from '../../components/InfoBox';
import PageTitle from '../../components/PageTitle';
import content from './copy';

class Upload extends Component {
  getType() {
    switch (get(this, 'props.match.path')) {
      case '/ladda-upp/minuc': {
        return 'MIN_UC';
      }
      case '/ladda-upp/personbevis': {
        return 'ID_PROOF';
      }
      case '/ladda-upp/inkomstbevis': {
        return 'INCOME_BASE';
      }
      case '/ladda-upp/hyresavtal': {
        return 'RENTAL_AGREEMENT';
      }
      case '/ladda-upp/hyresbevis': {
        return 'RENTAL_BASE';
      }
      default: {
        return null;
      }
    }
  }
  getContent() {
    return content[this.getType()];
  }
  getTitle() {
    return this.getContent().title;
  }
  getInfo() {
    return this.getContent().infoText();
  }

  render() {
    return (
      <div>
        <PageTitle>{this.getTitle()}</PageTitle>
        <InfoBox header="Läs detta först">{this.getInfo()}</InfoBox>
        <FileHandler fileType={this.getType()} />
      </div>
    );
  }
}

export default Upload;



// WEBPACK FOOTER //
// ./src/views/Upload/index.js